// import React, { useRef, useEffect, useState } from "react";

// const ScrollStory = () => {
//   const sectionsRef = useRef([]);
//   const [activeIndex, setActiveIndex] = useState(0);

//   const content = [
//     {
//       title: "Champions for the marginalized",
//       text: "standing with the poor, disabled, disaster-stricken, and those facing epidemics and injustice.",
//       img: "https://picsum.photos/600/400?random=1",
//     },
//     {
//       title: "Life is sacred",
//       text: "serving all people equally based on need, without discrimination of any kind.",
//       img: "https://picsum.photos/600/400?random=2",
//     },
//     {
//       title: "Responsive and present",
//       text: "meeting urgent needs wherever and whenever we can make a difference.",
//       img: "https://picsum.photos/600/400?random=3",
//     },
//     {
//       title: "Stronger together",
//       text: "partnering with communities and like-minded organizations to multiply our impact.",
//       img: "https://picsum.photos/600/400?random=3",
//     },
//     {
//       title: "Integrity at our core",
//       text: "maintaining full transparency and accountability to those we serve and our partners.",
//       img: "https://picsum.photos/600/400?random=3",
//     },
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       sectionsRef.current.forEach((section, index) => {
//         const rect = section.getBoundingClientRect();
//         const middle = window.innerHeight / 2;

//         if (rect.top <= middle && rect.bottom >= middle) {
//           setActiveIndex(index);
//         }
//       });
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <div style={{ background: "#0f172a", color: "white" }}>
//       {/* SCROLL CONTAINER */}
//       <div
//         style={{
//           display: "flex",
//           // position: "relative",
//           maxWidth: "1200px",
//           margin: "0 auto",
//           // minHeight: "100px"
//         }}
//       >
//         {/* LEFT PANEL (scrolls text) */}
//         <div style={{ flex: 1, padding: "100px 20px" }}>
//           {content.map((item, index) => (
//             <section
//               key={index}
//               ref={(el) => (sectionsRef.current[index] = el)}
//               style={{
//                 minHeight: "70vh",
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <div>
//                 <h2 style={{ fontSize: "32px", marginBottom: "10px" }}>
//                   {item.title}
//                 </h2>
//                 <p style={{ fontSize: "18px", lineHeight: "1.6", color: "#d1d5db" }}>
//                   {item.text}
//                 </p>
//               </div>
//             </section>
//           ))}
//         </div>

//         {/* RIGHT PANEL (fixed for the whole container) */}
      //   <div
      //     style={{
      //       flex: 1,
      //       position: "sticky",
      //       top: "100px",
      //       height: "400px",
      //       display: "flex",
      //       alignItems: "center",
      //       justifyContent: "center",
      //     }}
      //   >
      //     <div
      //       style={{
      //         width: "100%",
      //         height: "100%",
      //         borderRadius: "16px",
      //         backgroundImage: `url(${content[activeIndex].img})`,
      //         backgroundSize: "cover",
      //         backgroundPosition: "center",
      //         transition: "background 0.6s ease-in-out",
      //       }}
      //     />
      //   </div>
      // </div>
//     </div>
//   );
// };

// export default ScrollStory;

// =================================================================================================================================
// import React, { useRef, useEffect, useState } from "react";
// import { useLocation } from "react-router";



// const contentVal = [
//   {
//     title: "Champions for the marginalized",
//     text: "standing with the poor, disabled, disaster-stricken, and those facing epidemics and injustice.",
//     img: "https://picsum.photos/600/400?random=1",
//   },
//   {
//     title: "Life is sacred",
//     text: "serving all people equally based on need, without discrimination of any kind.",
//     img: "https://picsum.photos/600/400?random=2",
//   },
//   {
//     title: "Responsive and present",
//     text: "meeting urgent needs wherever and whenever we can make a difference.",
//     img: "https://www.fountainafrica.org/wp-content/uploads/2020/01/3.jpg",
//   },
//   {
//     title: "Stronger together",
//     text: "partnering with communities and like-minded organizations to multiply our impact.",
//     img: "https://picsum.photos/600/400?random=4",
//   },
//   {
//     title: "Integrity at our core",
//     text: "maintaining full transparency and accountability to those we serve and our partners.",
//     img: "https://www.fountainafrica.org/wp-content/uploads/2020/01/4-1536x839.jpg",
//   },
// ];

// const ScrollStory = ({ ourValues }) => {
//   const location = useLocation()
//   const sectionsRef = useRef([]);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [userScrolling, setUserScrolling] = useState(false);
//   const [content, setValuesContent] = useState(contentVal || [])



//   useEffect(()=>{
//     if(ourValues){
//       setValuesContent(ourValues)
//     }
//   },[ourValues,location])


 
  

//   useEffect(() => {
//     const scrollContainer = document.getElementById("scrollable-text");

//     let scrollPos = 0;
//     let animationFrame;

//     const scrollSpeed = 0.2;

//     const handleScroll = () => {
//       sectionsRef?.current?.forEach((section, index) => {
//         const rect = section?.getBoundingClientRect();
//         const parentRect = scrollContainer?.getBoundingClientRect();
//         const middle = parentRect.top + parentRect.height / 2;

//         if (rect?.top <= middle && rect?.bottom >= middle) {
//           setActiveIndex(index);
//         }
//       });
//     };

//     scrollContainer.addEventListener("scroll", handleScroll);


//      // 🔹 Auto-scroll loop
//      const autoScroll = () => {
//       if (!userScrolling && scrollContainer) {
//         scrollPos += scrollSpeed;
//         scrollContainer.scrollTop = scrollPos;
//         if (
//           scrollPos <
//           scrollContainer.scrollHeight - scrollContainer.clientHeight
//         ) {
//           animationFrame = requestAnimationFrame(autoScroll);
//         }
//       }
//     };

//      // 🔹 Detect user interaction
//      const handleUserScroll = () => {
//       // if(ourValues?.length>1 || content?.length>1){
//       setUserScrolling(true);
//       cancelAnimationFrame(animationFrame);
//       // }
//     };

//     scrollContainer.addEventListener("wheel", handleUserScroll, { passive: true });
//     scrollContainer.addEventListener("touchmove", handleUserScroll, { passive: true });

//     // 🔹 Start auto scroll
//     animationFrame = requestAnimationFrame(autoScroll);
//     return () =>{ 
//       cancelAnimationFrame(animationFrame);
//       scrollContainer.removeEventListener("scroll", handleScroll);
//       scrollContainer.removeEventListener("wheel", handleUserScroll);
//       scrollContainer.removeEventListener("touchmove", handleUserScroll);
//       // scrollContainer.removeEventListener("scroll", handleScroll)};
//       }
//   }, [userScrolling]);

//   return (
//     <div
//       style={{
//         background: "#0f172a",
//         color: "white",
//         height: "80vh", // keeps the section fixed
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           maxWidth: "1200px",
//           width: "100%",
//           height: "80vh",
//           borderRadius: "16px",
//           overflow: "hidden",
//           // boxShadow: "0 0 30px rgba(0,0,0,0.3)",
//         }}
//       >
//         {/* LEFT SCROLLABLE TEXT */}
//         <div
//           id="scrollable-text"
//           style={{
//             flex: 1,
//             overflowY: "scroll",
//             padding: "100px 40px",
//             marginTop:"80px",
//             scrollBehavior: "smooth",
//             display: "flex",
//             flexDirection:"column",
//             height: "50vh",
            
//           }}
//         >
//           {content?.length>=0?
          
//           (content?.map((item, index) => (
//             <section
//               key={index}
//               ref={(el) => (sectionsRef.current[index] = el)}
//               style={{
//                 minHeight: "40vh", // Each text block scrolls in its own section
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <div>
//                 <h2 style={{ fontSize: "28px", marginBottom: "10px" }}>
//                   {item?.title}
//                 </h2>
//                 <p
//                   style={{
//                     fontSize: "18px",
//                     lineHeight: "1.6",
//                     color: "#d1d5db",
//                   }}
//                 >
//                   {item?.text}
//                 </p>
//               </div>
//             </section>
//           ))):""
//         }
//         </div>

//         {/* RIGHT FIXED IMAGE */}


//       <div
//           style={{
//             flex: 1,
//             position: "sticky",
//             top: "100px",
//             height: "400px",
//             width:"100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             borderRadius: "16px"
            
//           }}
//         >
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               borderRadius: "16px",
//               backgroundImage: `url(${content[activeIndex]?.img})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               transition: "background 0.6s ease-in-out",
//               boxShadow: "0 0 30px rgba(191, 179, 211, 0.3)",
//             }}
//           />
//         </div>
//         </div>
//     </div>
//   );
// };

// export default ScrollStory;

// ================================================================================= new update 2

// import React, { useRef, useEffect, useState } from "react";
// import { useLocation } from "react-router";

// const contentVal = [
//   {
//     title: "Champions for the marginalized",
//     text: "standing with the poor, disabled, disaster-stricken, and those facing epidemics and injustice.",
//     img: "https://picsum.photos/600/400?random=1",
//   },
//   {
//     title: "Life is sacred",
//     text: "serving all people equally based on need, without discrimination of any kind.",
//     img: "https://picsum.photos/600/400?random=2",
//   },
//   {
//     title: "Responsive and present",
//     text: "meeting urgent needs wherever and whenever we can make a difference.",
//     img: "https://www.fountainafrica.org/wp-content/uploads/2020/01/3.jpg",
//   },
//   {
//     title: "Stronger together",
//     text: "partnering with communities and like-minded organizations to multiply our impact.",
//     img: "https://picsum.photos/600/400?random=4",
//   },
//   {
//     title: "Integrity at our core",
//     text: "maintaining full transparency and accountability to those we serve and our partners.",
//     img: "https://www.fountainafrica.org/wp-content/uploads/2020/01/4-1536x839.jpg",
//   },
// ];

// const ScrollStory = ({ ourValues }) => {
//   const location = useLocation();
//   const sectionsRef = useRef([]);
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [userScrolling, setUserScrolling] = useState(false);
//   const [content, setValuesContent] = useState(contentVal);

//   useEffect(() => {
//     if (ourValues) {
//       setValuesContent(ourValues);
//     }
//   }, [ourValues, location]);

//   useEffect(() => {
//     const scrollContainer = document.getElementById("scrollable-text");
//     if (!scrollContainer) return;

//     let animationFrame;
//     let scrollPos = 0;
//     const scrollSpeed = 0.35;

//     // ---- USER INTERRUPTS AUTOSCROLL ----
//     const handleUserScroll = () => {
//       setUserScrolling(true);
//       cancelAnimationFrame(animationFrame);
//     };

//     scrollContainer.addEventListener("wheel", handleUserScroll, { passive: true });
//     scrollContainer.addEventListener("touchmove", handleUserScroll, { passive: true });

//     // ---- UPDATE IMAGE BASED ON SCROLL ----
//     const handleScroll = () => {
//       sectionsRef.current.forEach((section, index) => {
//         if (!section) return;

//         const rect = section.getBoundingClientRect();
//         const containerRect = scrollContainer.getBoundingClientRect();
//         const mid = containerRect.top + containerRect.height / 2;

//         if (rect.top < mid && rect.bottom > mid) {
//           setActiveIndex(index);
//         }
//       });
//     };

//     scrollContainer.addEventListener("scroll", handleScroll);

//     // ---- AUTOSCROLL LOOP ----
//     const autoScroll = () => {
//       if (!userScrolling) {
//         scrollPos += scrollSpeed;
//         scrollContainer.scrollTop = scrollPos;

//         if (scrollPos < scrollContainer.scrollHeight - scrollContainer.clientHeight) {
//           animationFrame = requestAnimationFrame(autoScroll);
//         }
//       }
//     };

//     // Start after initial rendering
//     setTimeout(() => requestAnimationFrame(autoScroll), 400);

//     return () => {
//       cancelAnimationFrame(animationFrame);
//       scrollContainer.removeEventListener("scroll", handleScroll);
//       scrollContainer.removeEventListener("wheel", handleUserScroll);
//       scrollContainer.removeEventListener("touchmove", handleUserScroll);
//     };
//   }, [content, userScrolling]);

//   return (
//     <div
//       style={{
//         background: "#0f172a",
//         color: "white",
//         height: "80vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           maxWidth: "1200px",
//           width: "100%",
//           height: "80vh",
//           borderRadius: "16px",
//           overflow: "hidden",
//         }}
//       >
//         {/* LEFT SCROLLABLE TEXT */}
//         <div
//           id="scrollable-text"
//           style={{
//             flex: 1,
//             overflowY: "scroll",
//             padding: "100px 40px",
//             marginTop: "80px",
//             display: "flex",
//             flexDirection: "column",
//             height: "70vh", // Fixed height so container can scroll fully
//           }}
//         >
//           {content.map((item, index) => (
//             <section
//               key={index}
//               ref={(el) => (sectionsRef.current[index] = el)}
//               style={{
//                 minHeight: "40vh",
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <div>
//                 <h2 style={{ fontSize: "28px", marginBottom: "10px" }}>
//                   {item.title}
//                 </h2>
//                 <p
//                   style={{
//                     fontSize: "18px",
//                     lineHeight: "1.6",
//                     color: "#d1d5db",
//                   }}
//                 >
//                   {item.text}
//                 </p>
//               </div>
//             </section>
//           ))}
//         </div>

//         {/* RIGHT FIXED IMAGE */}
//         <div
//           style={{
//             flex: 1,
//             position: "sticky",
//             top: "100px",
//             height: "400px",
//             width: "100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             borderRadius: "16px",
//           }}
//         >
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               borderRadius: "16px",
//               backgroundImage: `url(${content[activeIndex]?.img})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               transition: "background 0.6s ease-in-out",
//               boxShadow: "0 0 30px rgba(191, 179, 211, 0.3)",
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ScrollStory;


// ================================================================================ New Update 3 ==========================

// import React, { useRef, useEffect, useState } from "react";
// import { useLocation } from "react-router";

// const contentVal = [
//   {
//     title: "Champions for the marginalized",
//     text: "standing with the poor, disabled, disaster-stricken, and those facing epidemics and injustice.",
//     img: "https://picsum.photos/600/400?random=1",
//   },
//   {
//     title: "Life is sacred",
//     text: "serving all people equally based on need, without discrimination of any kind.",
//     img: "https://picsum.photos/600/400?random=2",
//   },
//   {
//     title: "Responsive and present",
//     text: "meeting urgent needs wherever and whenever we can make a difference.",
//     img: "https://www.fountainafrica.org/wp-content/uploads/2020/01/3.jpg",
//   },
//   {
//     title: "Stronger together",
//     text: "partnering with communities and like-minded organizations to multiply our impact.",
//     img: "https://picsum.photos/600/400?random=4",
//   },
//   {
//     title: "Integrity at our core",
//     text: "maintaining full transparency and accountability to those we serve and our partners.",
//     img: "https://www.fountainafrica.org/wp-content/uploads/2020/01/4-1536x839.jpg",
//   },
// ];

// const ScrollStory = ({ ourValues }) => {
//   const location = useLocation();
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [userScrolling, setUserScrolling] = useState(false);
//   const [content, setContent] = useState(contentVal);

//   useEffect(() => {
//     if (ourValues) {
//       setContent(ourValues);
//     }
//   }, [ourValues, location]);

//   // AUTO SWITCH TEXT (slide-show style)
//   useEffect(() => {
//     if (userScrolling) return; // stop auto animation when user interacts

//     const interval = setInterval(() => {
//       setActiveIndex((prev) =>
//         prev + 1 < content.length ? prev + 1 : prev
//       );
//     }, 3500); // change every 3.5s

//     return () => clearInterval(interval);
//   }, [content, userScrolling]);

//   // USER INTERRUPTS AUTO SWITCH
//   useEffect(() => {
//     const stopAuto = () => setUserScrolling(true);

//     window.addEventListener("wheel", stopAuto, { passive: true });
//     window.addEventListener("touchmove", stopAuto, { passive: true });

//     return () => {
//       window.removeEventListener("wheel", stopAuto);
//       window.removeEventListener("touchmove", stopAuto);
//     };
//   }, []);

//   return (
//     <div
//       style={{
//         background: "#0f172a",
//         color: "white",
//         height: "80vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <div
//         style={{
//           display: "flex",
//           maxWidth: "1200px",
//           width: "100%",
//           height: "80vh",
//           borderRadius: "16px",
//           overflow: "hidden",
//         }}
//       >
//         {/* LEFT TEXT PANEL (only ONE text at a time) */}
//         <div
//           style={{
//             flex: 1,
//             padding: "100px 40px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             textAlign: "left",
//             transition: "opacity 0.6s ease",
//           }}
//         >
//           <div style={{ maxWidth: "500px" }}>
//             <h2 style={{ fontSize: "32px", marginBottom: "10px" }}>
//               {content[activeIndex]?.title}
//             </h2>
//             <p
//               style={{
//                 fontSize: "18px",
//                 lineHeight: "1.6",
//                 color: "#d1d5db",
//               }}
//             >
//               {content[activeIndex]?.text}
//             </p>
//           </div>
//         </div>

//         {/* RIGHT IMAGE PANEL */}
//         <div
//           style={{
//             flex: 1,
//             position: "sticky",
//             top: "100px",
//             height: "400px",
//             width: "100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             borderRadius: "16px",
//           }}
//         >
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               borderRadius: "16px",
//               backgroundImage: `url(${content[activeIndex]?.img})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               transition: "background-image 0.6s ease-in-out",
//               boxShadow: "0 0 30px rgba(191, 179, 211, 0.3)",
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ScrollStory;

// ===================================================================================================UPDATE 4


import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";

const contentVal = [
  {
    title: "Champions for the marginalized",
    text: "standing with the poor, disabled, disaster-stricken, and those facing epidemics and injustice.",
    img: "https://picsum.photos/600/400?random=1",
  },
  {
    title: "Life is sacred",
    text: "serving all people equally based on need, without discrimination of any kind.",
    img: "https://picsum.photos/600/400?random=2",
  },
  {
    title: "Responsive and present",
    text: "meeting urgent needs wherever and whenever we can make a difference.",
    img: "https://www.fountainafrica.org/wp-content/uploads/2020/01/3.jpg",
  },
  {
    title: "Stronger together",
    text: "partnering with communities and like-minded organizations to multiply our impact.",
    img: "https://picsum.photos/600/400?random=4",
  },
  {
    title: "Integrity at our core",
    text: "maintaining full transparency and accountability to those we serve and our partners.",
    img: "https://www.fountainafrica.org/wp-content/uploads/2020/01/4-1536x839.jpg",
  },
];

const ScrollStory = ({ ourValues }) => {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [content, setContent] = useState(contentVal);

  useEffect(() => {
    if (ourValues) setContent(ourValues);
  }, [ourValues, location]);

  // AUTOPLAY WHEN NOT HOVERED
  useEffect(() => {
    if (isHovered) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev + 1 < content.length ? prev + 1 : 0
      );
    }, 3500);

    return () => clearInterval(interval);
  }, [isHovered, content]);

  const goNext = () => {
    setActiveIndex((prev) =>
      prev + 1 < content.length ? prev + 1 : 0
    );
  };

  const goPrev = () => {
    setActiveIndex((prev) =>
      prev - 1 >= 0 ? prev - 1 : content.length - 1
    );
  };

  return (
    <div
      style={{
        background: "#0f172a",
        color: "white",
        height: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          maxWidth: "1200px",
          width: "100%",
          height: "80vh",
          borderRadius: "16px",
          overflow: "hidden",
        }}
      >

        {/* LEFT CONTENT AREA (hover controlled) */}
        <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            flex: 1,
            padding: "100px 40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            textAlign: "left",
          }}
        >
          <div style={{ maxWidth: "500px", transition: "opacity 0.5s ease" }}>
            <h2 style={{ fontSize: "32px", marginBottom: "10px" }}>
              {content[activeIndex]?.title}
            </h2>
            <p style={{ fontSize: "18px", lineHeight: "1.6", color: "#d1d5db" }}>
              {content[activeIndex]?.text}
            </p>
          </div>

          {/* MANUAL NAV BUTTONS (only visible when hovering) */}
          {isHovered && (
            <>
              <button
                onClick={goPrev}
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.15)",
                  border: "none",
                  padding: "10px 14px",
                  borderRadius: "50%",
                  cursor: "pointer",
                  color: "white",
                }}
              >
                ‹
              </button>

              <button
                onClick={goNext}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.15)",
                  border: "none",
                  padding: "10px 14px",
                  borderRadius: "50%",
                  cursor: "pointer",
                  color: "white",
                }}
              >
                ›
              </button>
            </>
          )}
        </div>

        {/* RIGHT IMAGE PANEL */}
        <div
          style={{
            flex: 1,
            position: "sticky",
            top: "100px",
            height: "400px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "16px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "16px",
              backgroundImage: `url(${content[activeIndex]?.img})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transition: "background-image 0.6s ease-in-out",
              boxShadow: "0 0 30px rgba(191, 179, 211, 0.3)",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ScrollStory;

